import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { resolveSentryEnvironment } from './lib/sentryEnv'
import { startAuthSync } from './lib/authSync'
import { startIdleWatch } from './lib/idleExpiry'
import { installPreloadErrorHandler } from './lib/staleBundle'

// Env-gated: without VITE_SENTRY_DSN baked in at build time this is a
// complete no-op. Errors only — no tracing, no replay, no PII.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // VITE_APP_ENV, not MODE — a staging build is still a production *build*,
    // so MODE alone reported staging errors as 'production'.
    environment: resolveSentryEnvironment(),
    tracesSampleRate: 0,
    sendDefaultPii: false,
  })
}

// Adopt token rotations written by sibling tabs. Installed once, for the
// life of the tab, deliberately outside the React tree: the subscription
// belongs to the document, not to whatever route happens to be mounted.
startAuthSync()

// End the session after VITE_AUTH_IDLE_HOURS with no input in any tab — the
// bound the owner put on shared storage. Its first check runs here, before
// the first render, so a stale session is gone before it can paint.
startIdleWatch()

// A chunk from an older deploy failed to load: offer a reload (StaleBundlePrompt).
// Installed before the first render, so the first lazy route is covered.
installPreloadErrorHandler()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
